import httpHubless from 'hub-http/clients/noPortalApiClient';
import Url from 'urlinator/Url';
const URL_LOADED_LOCAL = Url.loaded.local;
const API_BASE = 'passkey-login/settings';
export default class PasskeysAPI {
  static registerPasskey(email) {
    const requestData = {
      data: {
        redirectToLocal: URL_LOADED_LOCAL,
        email
      }
    };
    return httpHubless.post(`${API_BASE}/registration/initiate`, requestData);
  }
  static validatePasskey(publicKeyCredentialCreationOptions, publicKeyRegistrationCredential) {
    const clientExtensionResults = publicKeyRegistrationCredential.getClientExtensionResults();
    const response = publicKeyRegistrationCredential.response;
    const requestData = {
      data: {
        publicKeyCredentialCreationOptions,
        publicKeyRegistrationCredential: {
          clientExtensionResults,
          authenticatorAttachment: publicKeyRegistrationCredential.authenticatorAttachment,
          id: publicKeyRegistrationCredential.id,
          type: publicKeyRegistrationCredential.type,
          response: {
            attestationObject: btoa(String.fromCharCode(...new Uint8Array(response.attestationObject))),
            clientDataJSON: btoa(String.fromCharCode(...new Uint8Array(response.clientDataJSON)))
          }
        }
      }
    };
    return httpHubless.post(`${API_BASE}/registration/validate`, requestData);
  }
  static fetchPasskeys(userId) {
    return httpHubless.get(API_BASE, {
      query: {
        stashedUserId: userId
      }
    });
  }
  static deletePasskey(credentialId) {
    return httpHubless.delete(API_BASE, {
      data: {
        credentialId
      }
    });
  }
  static renamePasskey(credentialId, name) {
    return httpHubless.post(`${API_BASE}/rename/credential`, {
      data: {
        credentialId,
        name
      }
    });
  }
}